module.exports = __webpack_public_path__ + "assets/images/numberofChairs-03.b08edc50a18160e757f60bd586bd19f9.svg";